import type { AppModule } from '@/app/app-module.types';
import { ShieldIcon } from '@/shared/icons';
import { GUARANTEE_ROLES } from '@/shared/guards/roles';
import { guaranteeContainer } from './di/container';
import { GuaranteeRepositoryToken } from './di/tokens';
import { guaranteeRoutes } from './presentation/routes';

/**
 * Campanhas de garantia estendida do MedQ (`aristo-medq` no monolith). Ver
 * docs/reference/modules/aristo-medq.md § A tela de campanhas.
 */
export const guaranteeModule: AppModule = {
  name: 'guarantee',

  register(container) {
    container.register(
      GuaranteeRepositoryToken,
      () => guaranteeContainer.repository,
    );
  },

  routes: guaranteeRoutes,

  menu: [
    {
      label: 'Campanhas de garantia',
      to: '/guarantee/campaigns',
      icon: ShieldIcon,
      section: 'commercial',
      order: 5,
      roles: GUARANTEE_ROLES,
    },
  ],
};
